import React, { useContext } from 'react'

import { AccountContext } from 'core/context'
import { useLanguage } from 'context/LanguageContext'
import { PopupAdapter } from 'shared/components/popups/PopupAdapter'
import { RegisterForm } from 'shared/components/RegisterForm'
import { PARTICLES_PRESET, useParticlesBackground } from 'shared/hooks'
import 'particles.js'

/** Меньше частиц для нижнего CTA-блока, чем в баннере. */
const JOIN_PARTICLES = {
    ...PARTICLES_PRESET,
    particles: {
        ...PARTICLES_PRESET.particles,
        number: { value: 70, density: { enable: false } },
    },
}

import translations, { Translations } from './translations'

import s from './Join.module.scss'

/**
 * Final CTA block внизу лендинга.
 * Скрыт для авторизованных пользователей.
 */
export const Join: React.FC = React.memo(() => {
    const { language } = useLanguage()
    const { accountData } = useContext(AccountContext)
    const t: Translations = translations[language] || translations.en

    useParticlesBackground('particles-js-join', JOIN_PARTICLES)

    if (accountData?.id) return null

    return (
        <div className={s.wrapper}>
            <div
                id="particles-js-join"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 0,
                }}
            />
            <div className={s.content}>
                <br></br>

                <h2 className={s.title}>{t.title}</h2>

                <p className={s.subtitle}>{t.subtitle}</p>

                <div className={s.ctaRow}>
                    <PopupAdapter
                        component={RegisterForm}
                        formId="joinRegForm"
                        buttonText={t.ctaPrimary}
                        buttonOption={{
                            type: 'primary',
                            className: s.ctaPrimary,
                        }}
                        modalOptions={{
                            width: 480,
                            footer: null,
                            maskClosable: true,
                        }}
                    />
                </div>

                <div className={s.benefits}>
                    <span>{t.benefit1}</span>
                    <span>{t.benefit2}</span>
                    <span>{t.benefit3}</span>
                    <span>{t.benefit4}</span>
                </div>

                <div className={s.riskNote}>{t.riskNote}</div>
            </div>
        </div>
    )
})
